export enum ArticleCategoryEnum {
    CAFE_STORY,
    TUTORIALS
}
